import { Input } from '@art-of-hospitality-solutions-llc/ui-kit/components/input';

import FieldShell from './FieldShell';

interface TextInputFieldProps {
  title?: string;
  description?: string;
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;
}

export default function TextInputField({
  title,
  description,
  placeholder,
  value,
  onChange,
}: TextInputFieldProps) {
  return (
    <FieldShell title={title} description={description}>
      <Input
        value={value ?? ''}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
    </FieldShell>
  );
}
